<template>
    <div class="offline nav-bar-fixed" >
        <van-nav-bar title="月结账单线下支付审批" left-arrow fixed @click-left="back"/>
        <van-cell-group title="转账内容">
            <van-cell title="银行流水号" :value="underLinepay.bank_water" />
            <van-cell title="转账金额" :value="underLinepay.bank_water_money"  />
            <van-cell title="所属会员" :value="appUser.trueName"  />
            <van-cell title="会员备注" :value="underLinepay.remark"  />
        </van-cell-group>
        <van-cell-group title="审批流信息">
            <van-cell title="审批类型" :value="workFlow.workFlowTypeName" />
            <van-cell title="申请时间" :value="workFlow.createtime"  />
            <van-cell title="停滞时间" :value="workFlow.deadTime"  />
        </van-cell-group>
        <van-cell-group title="转账凭证" v-if="underLinepay.pz_url">
            <img class="voucher-img"
                 :src="underLinepay.pz_url" >
        </van-cell-group>
        <van-cell-group title="审核" >
            <van-row>
                <van-col span="24" class="textareaBox">
                    <van-field type="textarea" v-model="remark" />
                </van-col>
                <van-col span="12" style="margin-top: 10px;text-align: center">
                    <van-button type="info" size="small" @click="savedeal(1)">通过</van-button>
                </van-col>
                <van-col span="12" style="margin-top: 10px">
                    <van-button type="danger" size="small" class="danger" @click="savedeal(0)">驳回</van-button>
                </van-col>
            </van-row>
        </van-cell-group>
    </div>
</template>
<script>
    import {
        NavBar, Cell, CellGroup, Field, Button, Row, Col, Collapse, CollapseItem, Dialog,
    } from "vant";

    export default {
        name: "ApprovalDetail",
        components: {
            [Dialog.name]: Dialog,
            [NavBar.name]: NavBar,
            [CellGroup.name]: CellGroup,
            [Cell.name]: Cell,
            [Field.name]: Field,
            [Button.name]: Button,
            [Row.name]: Row,
            [Col.name]: Col,
            [Collapse.name]: Collapse,
            [CollapseItem.name]: CollapseItem,
        },
        data() {
            return {
                workflowId:-1,
                workFlow:{},
                remark:'',
                workflowLog:[],
                underLinepay:{},
                appUser:{}
            }
        },
        mounted() {
            let that = this;
            that.workflowId=localStorage.getItem('workflow_id');
            that.loadWorkflowInfo();
        },
        methods: {
            loadWorkflowInfo(){
                let that = this;
                that.$api.post(that.jumuc.userCenter.selAuditedDetailInfo,{'workFlowId':that.workflowId,'flag':true},res => {
                    if(res && res.success){
                        let workflow=res.data.workFlow;
                        that.workFlow=workflow
                        that.workflowLog=res.data.workflowLog;
                        that.underLinepay=res.data.underLinepay;
                        that.appUser=res.data.appUser;
                    }
                })
            },
            back(){
                history.back();
            },
            savedeal(status) {
                let that = this;
                if (status == 0 && !that.remark) {
                    Dialog.alert({
                        message: "驳回内容不能为空"
                    });
                    return;
                }
                that.$api.post(that.jumuc.stock.savedeal, {
                    workflowId: that.workflowId,
                    status: status,
                    remark: that.remark,
                    currentSquence:1,
                }, res => {
                    Dialog.alert({
                        message: res.msg
                    }).then(() => {
                            that.$router.push({
                                path: '/staff/approval'
                            });
                        });
                })
            }
        }
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3C6EEB;
    body {
        background: #f7f7ff;
    }

    .textareaBox{
        margin-top: 10px;
        width: 95%!important;
        border: 1px #C2C2C2 solid;
        margin-left: 2.5%!important;
    }
    #app .van-tabs__line {
        height: 45px;
        background-color: rgba(255, 255, 255, 0.1);
        min-width: 100px;
        left: -20px;
    }
    .offline .voucher-img {
        width: 100%;
        padding:0px 3%;
    }
    .appr-tabs {
        .van-tab {
            color: #fff;
        }
        .van-tabs__nav {
            background-color: @bule-thame;
        }
        .van-hairline--top-bottom::after {
            border-width: 0;
        }
    }
    .pay-by {
        padding: 10px;
        .pay-item {
            background-color: #fff;
            padding: 10px;
            position: relative;
            margin-bottom: 10px;
            p {
                color: #ccc;
                font-size: 12px;
                padding: 5px 0;
            }
            &-ft {
                padding-top: 10px;
                p {
                    color: #333;
                }
            }
            .pay-state {
                text-align: right;
                color: @bule-thame;
                i {
                    display: inline-block;
                    padding: 5px;
                    border-radius: 100%;
                    background-color: @bule-thame;
                }
            }
            &-rd {
                position: absolute;
                top: 0;
                left: -5px;
                width: 10px;
                height: 100%;
                background-color: @bule-thame;
                border-radius: 10px 0 0 10px;
            }

            &.ok {
                .pay-state {
                    color: #28a745;
                    i {
                        background-color: #28a745;
                    }
                }
                .pay-item-rd {
                    background-color: #28a745;
                }
            }
            &.err {
                .pay-state {
                    color: #ffc107;
                    i {
                        background-color: #ffc107;
                    }
                }
                .pay-item-rd {
                    background-color: #ffc107;
                }
            }
        }
    }
</style>
